import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import MobileHeader from '../../components/MobileHeader';

import '../MobileWrapper.scss';
import './SwitchCompanyWrapper.scss';
import mobileBridge from '../../helpers/MobileBridge';
import mobileCompanySelectImage from '../../assets/images/mobile-company-select.png';
import dashboardIcon from '../../assets/images/dashboard-blue.svg';

export class SwitchCompanyWrapper extends BasePage {

  componentDidMount() {
    mobileBridge.initialize(this.props.history);
  }

  handleNavigateBack() {
    mobileBridge.fireNativeEvent('native.navigateTo', {
      data: {
        notification_type: 'Back',
      },
    });
  }

  render() {

    return (
      <div className='mobile-wrapper'>
        <MobileHeader
          headerTitle={'Companies'}
          handleClear={this.handleClear}
          navigateBack={this.handleNavigateBack}
        />
        <div className="content-wrapper">
          <div className="switch-company-notify">
            <img className="switch-company-notify-image" src={mobileCompanySelectImage} alt="Select"/>
            <div className="switch-company-notify-instructions">
            <div className="switch-company-notify-text">Change your Company easily</div>
            <div className="switch-company-notify-text-2">
              <div className="switch-company-notify-text">from the top of the Dashboard</div>
              <img className="switch-company-dashboard-icon" src={dashboardIcon} alt="Dashboard"/>
            </div>
          </div>
          </div>
          {/*
          <SwitchCompany
            companies={ this.props.currentUser.companies }
            currentUser={ this.props.currentUser }
            currentCompany={ this.props.currentCompany }
            affiliateCompanies={ this.props.currentUser.vendor_companies }
          />
          */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    permissions: state.new_users.permissions,
  };
};

export default withRouter(connect(mapStateToProps)(SwitchCompanyWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/SwitchCompanyWrapper/index.js